import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {trackAction} from "../queries/tracking";
import {UI_TRACKING_ACTION} from "../types/trackingTypes";

// 1. Definiamo la forma dello stato
interface NavigationContextType {
    previousPage: string | null;
    currentPage: string;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

// 2. Il Provider che gestisce la logica
export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const [navigation, setNavigation] = useState<NavigationContextType>({
        previousPage: null,
        currentPage: location.pathname,
    });

    // Usiamo una ref per ricordare dove siamo, senza scatenare render infiniti
    const lastPath = useRef<string>(location.pathname);

    useEffect(() => {
        // Ogni volta che l'URL cambia (anche con le freccine)
        if (lastPath.current !== location.pathname) {
            setNavigation({
                previousPage: lastPath.current,
                currentPage: location.pathname,
            });
            lastPath.current = location.pathname;
        }

        trackAction(UI_TRACKING_ACTION.NAVIGATION, {path: location.pathname});

    }, [location.pathname]);

    return (
        <NavigationContext.Provider value={navigation}>
            {children}
        </NavigationContext.Provider>
    );
};

// 3. L'Hook personalizzato per usare questo stato ovunque
export const useNavigationHistory = () => {
    const context = useContext(NavigationContext);
    if (context === undefined) {
        throw new Error('useNavigationHistory must be used within a NavigationProvider');
    }
    return context;
};